import { actionCreatorFactory } from 'typescript-fsa';
import { PersistedAccount } from 'da-pcc-frontend-shared-domain';

const createAction = actionCreatorFactory('CONSUMER_ACCT');
export const fetchConsumerAccount = createAction.async<void, PersistedAccount>('FETCH');
